<template>
<div class="top">
  <div class="top-logo-bar">
    <div style="flex: 1"><img class="logo-img" :src="item.logoImg" alt=""></div>
    <div @click="doLocationHref(rightItem.adHrefUrl,1,rightItem)" v-for="(rightItem, rightIndex) in item.adList" :key="rightIndex" class="sign-in">
      <img class="sign-in-icon" :src="rightItem.imgUrl" />
      <div>{{rightItem.adName}}</div>
    </div>
  </div>
  <div v-show="scrollEndStatus" @click="doLocationHref(item.searchHref + searchText,0,'')" class="search-bar">{{searchText}}</div>
</div>
</template>

<script>
export default { 
  name: 'Top',
  data() {
    return {
    }
  },
  props: {
    item: Object,
  },
  components: {
    
  },
  created() {
  },
  watch: {
  
  },
  computed: {
    searchText: function(){
      return this.$store.state.home.searchText
    },
    scrollEndStatus: function(){
      return this.$store.state.home.scrollEndStatus
    },
  },
  methods: {
    doLocationHref(url,trackStatus,obj){
      var self = this
      if(trackStatus == 1){
        this.$store.commit('doTrack',{
          href: url,
          columnDefineId: self.item.columnDefineId,
          ccId: obj.ccId,
          adId: obj.adId,
          adName: obj.adName,
          idType: 'adId'
        });
      }
      window.location.href = url
    },
  }
}
</script>

<style scoped>
.top{
  /* position: fixed;
  top: 0;
  left: 0;
  right: 0; */
  /* background: #fff url(./assets/top_bg.png) no-repeat;
  background-size: 100% 100%; */
  z-index: 9;
}
.top-logo-bar{
  width: 100vw;
  height: 46px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #333;
}
.logo-img{
  margin-left: 15px;
  width: 164px;
  display: block;
}
.sign-in, .news{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 18px;
}
.sign-in-icon{
  width: 18px;
  height: 18px;
  display: block;
}
.news-icon{
  width: 18px;
  height: 18px;
  background: url(./assets/news_icon.png) no-repeat;
  background-size: 100%;
}
.search-bar{
  width: 308px;
  height: 36px;
  border: 1px solid #F72D17;
  border-radius: 19px;
  margin-left: 15px;
  margin-top: 8px;
  color: #F72D17;
  font-size: 13px;
  line-height: 36px;
  padding-left: 37px;
  background: url(./assets/search_icon.png) no-repeat left 13px center;
  background-size: 18px;
}
</style>